import ExplanationTooltip from '../reusableElementsComponents/ExplanationTooltip';
import Assessments from '../reusableElementsComponents/Assessments';
// import {useSelector} from "react-redux";
import { t } from '../../content';


function TeamReviewAssessmentsEdit({data, updateData, dataEditedFlag, setDataEditedFlag}) {
    // const contentfulData = useSelector(state => state.contentfulData.all['General definations']?.fields);
    return (
        <div className="assessments-wrapper section">

            <p className='mar-20 bottom m bold'>
                Assessments
                <ExplanationTooltip>
                    <p>{t('teams.assessmentsInfo')}</p>
                </ExplanationTooltip>
            </p>

            <Assessments 
                data={{'assessments' : data}} 
                updateData={updateData}
                dataEditedFlag={dataEditedFlag}
                setDataEditedFlag={setDataEditedFlag}
            />
        </div>
    )
}

export default TeamReviewAssessmentsEdit

